var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCameraAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12.1363C2 9.58283 2 8.30601 2.59922 7.38883C2.85862 6.99178 3.19196 6.65087 3.58019 6.38557C4.15644 5.99177 4.87786 5.85102 5.9824 5.80072C6.50948 5.80072 6.9633 5.39223 7.06666 4.86363C7.22172 4.07074 7.90244 3.5 8.69304 3.5H11.307C12.0975 3.5 12.7782 4.07074 12.9334 4.86363C13.0367 5.39223 13.4905 5.80072 14.0176 5.80072C15.1222 5.85102 15.8435 5.99177 16.4198 6.38557C16.808 6.65087 17.1414 6.99178 17.4008 7.38883C18 8.30601 18 9.58283 18 12.1363C18 14.6899 18 15.9667 17.4008 16.8839C17.1414 17.2809 16.808 17.6218 16.4198 17.8872C15.523 18.5 14.2746 18.5 11.7778 18.5H8.22222C5.7254 18.5 4.47699 18.5 3.58019 17.8872C3.19196 17.6218 2.85862 17.2809 2.59922 16.8839C2.42997 16.6248 2.30853 16.3371 2.22138 16",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 11.875H7.5",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 9.25V14.5",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 9.25H15",
    stroke: "#121212",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraAdd);
export default __webpack_public_path__ + "static/media/CameraAdd.8b88598847c7250e37c136b7a7431e5d.svg";
export { ForwardRef as ReactComponent };